<div class="d-flex w-100">
  <div class="col-12 col-md-8 col-lg-7 left-container">
    <h3 class="m-0">{{ "Create an Account" | translate }}</h3>
    <p class="mt-4">{{ "Sign up now and unlock exclusive access!" | translate }}</p>

    <!-- Full Name -->
    <label>{{ "Full Name" | translate }}</label>
    <div class="input-container mt-1" [class.input-error]="nameError">
      <i class="bi bi-person fs-3 left-icon"></i>
      <input type="text" placeholder="{{ 'Enter your fullName' | translate }}" [(ngModel)]="user.name" />
    </div>
    <small class="error-msg" *ngIf="nameError">{{ nameError }}</small>

    <!-- Phone -->
    <div class="mt-3">
      <label>{{ "Phone Number" | translate }}</label>
      <div class="input-container mt-1" [class.input-error]="phoneError">
        <i class="bi bi-telephone left-icon"></i>
        <input type="text" placeholder="{{ 'Enter your phone number' | translate }}" [(ngModel)]="user.phone" />
      </div>
      <small class="error-msg" *ngIf="phoneError">{{ phoneError }}</small>
    </div>

    <!-- Password -->
    <div class="mt-3">
      <label>{{ "Password" | translate }}</label>
      <div class="input-container mt-1" [class.input-error]="passwordError">
        <i class="bi bi-lock left-icon"></i>
        <input type="{{ showPassword ? 'text' : 'password' }}" placeholder="{{ 'Enter your password' | translate }}"
          [(ngModel)]="user.sub" />
        <i class="eye-icon {{ showPassword ? 'bi-eye-slash' : 'bi bi-eye' }}" (click)="toggleShowPassword()"></i>
      </div>
      <small class="error-msg" *ngIf="passwordError">{{ passwordError }}</small>
    </div>

    <!-- Confirm Password -->
    <div class="mt-3">
      <label>{{ "Confirm Password" | translate }}</label>
      <div class="input-container mt-1" [class.input-error]="confirmPasswordError">
        <i class="bi bi-lock left-icon"></i>
        <input type="{{ showConfirmPassword ? 'text' : 'password' }}"
          placeholder="{{ 'Renter your password' | translate }}" [(ngModel)]="confirmPassword" />
        <i class="eye-icon {{ showConfirmPassword ? 'bi-eye-slash' : 'bi bi-eye' }}"
          (click)="toggleConfirmShowPassword()"></i>
      </div>
      <small class="error-msg" *ngIf="confirmPasswordError">{{ confirmPasswordError }}</small>
    </div>

    <button (click)="signUp()" class="w-100 btn mt-4"
      [disabled]="submitted && !isFormValid"
      [class.btn-disabled]="submitted && !isFormValid">
      {{ "Register" | translate }}
    </button>

    <div class="or-divider mt-4">
      <div class="line"></div>
      <label>{{ "Or" | translate }}</label>
      <div class="line"></div>
    </div>

    <div class="social mt-4">
      <button (click)="registerWithGoogle()">
        <img [src]="googleIcon" />
        {{ "Signup with Google" | translate }}
      </button>
    </div>

    <div class="text-center mt-4">
      {{ "Login with another account?" | translate }}
      <span class="bold-text" [routerLink]="'/' + lang + '/login'" [queryParams]="{ returnUrl: returnUrl }">
        {{ "Login" | translate }}
      </span>
    </div>
  </div>

  <div class="d-none d-md-block col-md-4 col-lg-5 right-container">
    <img width="50%" [src]="logo" />
  </div>
</div>